import "../../assets/css/payment-header.css";
import appSettings from "../../settings/appSettings";
import { useApplePayCapabilities } from "../../hooks/useApplePayCapabilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import PayPalButtonWrapper from "../../braintree/PayPalButtonWrapper";
import ApplePayButton from "../../applepay/ApplePayButton";
import { PhraseKey, Say } from "../../languages";

type Props = {
  toggleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled: boolean;
  checkoutExpanded: boolean;
  setOrderPayload: (orderPayload) => void;
  mainState: object;
  formEnabled: boolean;
  hasProduct: boolean;
  isKioskMode: boolean;
  tokenExErrorPhraseKey: PhraseKey;
};

const PaymentHeader = (props: Props) => {
  const {
    toggleClick,
    disabled,
    checkoutExpanded,
    setOrderPayload,
    hasProduct,
    isKioskMode,
    tokenExErrorPhraseKey
  } = props;
  const { enablePayPal, enableApplePay, applePayMerchantId } = appSettings;
  const applePayCapabilities = useApplePayCapabilities(applePayMerchantId, enableApplePay, isKioskMode);
  const showApplePayButton = applePayCapabilities.isCapable && !applePayCapabilities.isLoading;

  return (
    <div className="payment-options-header">
      <p className="payment-options-text">
        <Say phrase="payment_step.step_heading" />
      </p>
      <div className="payment-options">
        {tokenExErrorPhraseKey && (
          <div className="alert alert-danger">
            <Say phrase={tokenExErrorPhraseKey} />
          </div>
        )}

        {showApplePayButton && (
          <ApplePayButton setOrderPayload={setOrderPayload} hasProduct={hasProduct} />
        )}

        {enablePayPal && (
          <PayPalButtonWrapper setOrderPayload={setOrderPayload} hasProduct={hasProduct} />
        )}

        <button
          className="payment-options__item btn btn-primary"
          onClick={toggleClick}
          disabled={disabled || tokenExErrorPhraseKey !== null}>
          <Say phrase="payment_step.credit_debit_cta" />{" "}
          <FontAwesomeIcon icon={checkoutExpanded ? faChevronUp : faChevronDown} />
        </button>
      </div>
    </div>
  );
};

export default PaymentHeader;
